import { BaseController } from './BaseController';
import { UserRepository } from '../repository/UserRepository';

/**
 * 사용자 관련 비즈니스 로직을 처리하는 Controller 클래스입니다.
 */
export class UserController extends BaseController {
  static instance = null;

  /**
   * UserController의 인스턴스를 반환합니다.
   * @returns {UserController} UserController 인스턴스
   */
  static getInstance() {
    if (!UserController.instance) {
      UserController.instance = new UserController();
    }
    return UserController.instance;
  }

  /**
   * UserController 생성자
   */
  constructor() {
    super(new UserRepository());
  }

  /**
   * 서명 데이터를 생성합니다.
   * @param {string} address - 지갑 주소
   * @returns {Object} 서명 데이터
   */
  createSignature(address) {
    return { address };
  }

  /**
   * 회원가입을 처리합니다.
   * @param {Object} data - 회원가입 데이터
   * @param {string} data.email - 이메일
   * @param {string} data.address - 지갑 주소
   * @param {string} data.first_name - 이름
   * @param {string} data.last_name - 성
   * @param {string} data.signature - 서명 값
   * @returns {Promise<Object>} 생성된 사용자 정보
   */
  async signup(data) {
    try {
      // 스네이크 케이스를 카멜 케이스로 변환
      const camelCaseData = {
        email: data.email,
        address: data.address,
        firstName: data.first_name,
        lastName: data.last_name,
        signature: data.signature
      };
      
      return await this.repository.create(camelCaseData);
    } catch (error) {
      console.error('Error in signup:', error);
      throw error;
    }
  }

  /**
   * 주소를 기반으로 사용자 정보를 조회합니다.
   * @param {string} address - 지갑 주소
   * @returns {Promise<Object|null>} 사용자 정보 또는 null
   */
  async getUser(address) {
    try {
      if (!address) {
        throw new Error('지갑 주소가 필요합니다.');
      }
      
      return await this.repository.findByAddress(address);
    } catch (error) {
      console.error('Error in getUser:', error);
      throw error;
    }
  }
} 